import { render, staticRenderFns } from "./InventoryExpress.vue?vue&type=template&id=4b3341d1&scoped=true&"
import script from "./InventoryExpress.vue?vue&type=script&lang=js&"
export * from "./InventoryExpress.vue?vue&type=script&lang=js&"
import style0 from "./InventoryExpress.vue?vue&type=style&index=0&id=4b3341d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3341d1",
  null
  
)

export default component.exports